import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { promiseWithCatch } from 'src/app/common/app.helpers';
import { PaginationComponentShared } from 'src/app/components/shared/pagination/pagination-component.shared';
import { ItemsListContent } from 'src/app/interfaces/views.interface';
import { Community, Post, PostBasic, Project } from 'src/app/swagger-api';
import { CardType } from 'src/app/views/cards/cards.types';

@Component({
  selector: 'app-items-list',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemsListComponent extends PaginationComponentShared {
  @Input({ required: true }) public items: (PostBasic | Community | Project)[];
  @Input({ required: true }) public type: CardType;
  @Input({ required: true }) public noItemsTitle: string;

  @Input({ required: false }) public isExpired = false;
  @Input({ required: false }) public redirectToLoginIfNoSession = false;
  @Input({ required: false }) public itemsListContent: ItemsListContent<Post | Community | Project> | null = null;

  private router = inject(Router);

  // TODO: check if this logic should be
  public createItem(): void {
    if (this.itemsListContent?.createItemInfo?.createLink) {
      {
        promiseWithCatch(
          this.router.navigate([this.itemsListContent.createItemInfo.createLink], {
            state: this.itemsListContent?.createItemInfo,
          }),
        );
      }
    }
  }

  // TODO: check if this logic should be
  public isShowCreateButton(): boolean {
    return Boolean(this.itemsListContent?.createItemInfo && (Object.values(CardType) as string[]).includes(this.type));
  }
}
